import './lib/tokenManagerImpl';
import './index.css';

import { setApiConfig } from '@billx/api';
import { removeUserAuthTokens } from '@billx/utils';
import { createRoot } from 'react-dom/client';

import App from './App.tsx';

setApiConfig({
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
  socketUrl: import.meta.env.VITE_SOCKET_URL,
});

window.APP_ENV = import.meta.env.VITE_APP_ENVIRONMENT;

if (import.meta.env.DEV) {
  window.clearAuth = () => {
    removeUserAuthTokens();
    window.location.reload();
  };
}
createRoot(document.getElementById('root')!).render(<App />);
